import { Component, Input, OnInit } from '@angular/core';
import {
  LoadingController,
  ModalController,
  Platform
} from '@ionic/angular';
import { Events } from 'src/providers/apiservices/eventsservice';
import {
  GlobalService,
  ToastColors,
} from 'src/providers/apiservices/globalservices';
import { ComunicacaoProvider } from 'src/providers/comunicacao/comunicacao';
import { InformeVendasProvider } from 'src/providers/informevendas/informevendas';
import { TarefasProvider } from 'src/providers/tarefas/tarefas';

interface Leituras {
  lidas: ComunicadoDTO.RootObject[];
  naoLidas: ComunicadoDTO.RootObject[];
}

@Component({
  selector: 'app-message-informe',
  templateUrl: './message-informe.page.html',
  styleUrls: ['./message-informe.page.scss'],
})
export class MessageInformePage implements OnInit {
  @Input() id: string;
  @Input() idEmpresa: string;
  @Input() idAtividade: string;
  @Input() dataLimite = new Date().toISOString();
  public mensagem: any = null;

  shopping = '';
  nomeAtividade = 'Analisar alteração';
  nomeLoja = ' ';
  lucLoja = '';
  contratoLoja: number = null;
  comentarioAlteracao = '';

  isMobile: boolean = false;
  Atividades = [];

  constructor(
    private modalCtrl: ModalController,
    private comunicacaoProvider: ComunicacaoProvider,
    private globalService: GlobalService,
    private loadingController: LoadingController,
    private informeProvider: InformeVendasProvider,
    private tarefasProvider: TarefasProvider,
    private events: Events,
    private platform: Platform
  ) {}

  ngOnInit() {
    if (this.platform.is('ios') || this.platform.is('android')) {
      this.isMobile = true;
    }
  }

  ngAfterViewInit() {
    this.carregarTela();
  }

  calculateDifference(num1, num2) {
    if(isNaN(num1) || isNaN(num2))
    {
      return "0";
    }
    if (num1 == num2) return '0';
    return `${num1 > num2 ? '' : '+'}${num2 - num1}`;
  }

  async carregarTela() {
    const loading = await this.loadingController.create({ message: 'Aguarde...' });

    loading.present();

    try {
      if (!this.id || !this.idEmpresa) {
        this.globalService.presentToast(
          'Informe não encontrado',
          ToastColors.danger
        );
        return this.dismiss();
      }


      const response = await this.informeProvider.getInformeVendasByIdProcesso(
        this.id,
        this.idEmpresa
      );

      const erro = response.erro;
      const informe = response.Item?.informe;
      const contratoAtividades = response.Item?.contratoAtividades;

      if (erro || !informe) {
        this.globalService.presentToast(erro, ToastColors.danger);
        return;
      }

      this.mensagem = informe;
      this.shopping = informe.contrato?.idEmpresaNavigation?.nomEmpresa;
      this.nomeAtividade = 'Analisar alteração';
      this.nomeLoja = informe.contrato?.nomContrato;
      this.lucLoja = informe.contrato?.lucLoja;
      this.contratoLoja = informe.contrato?.numContrato ? parseInt(informe.contrato.numContrato) : null;

      if(Array.isArray(informe.comentarioAlteracaos) && informe.comentarioAlteracaos.length > 0){
        this.comentarioAlteracao = informe.comentarioAlteracaos[0].desComentario;
      }

      let atividades = [] as any;
      for (const atividade of informe.informeVendaAtividades || []) {
        let atividadeObj = {} as any;

        const contratoAtividade = contratoAtividades.find(
          (x) => x.idIndiceAtividade == atividade.idIndiceAtividade
        );

        if (atividades.find(e => e.idAtividade == contratoAtividade.idAtividade && e.idIndiceAtividade == contratoAtividade.idIndiceAtividade)) {
          if (atividade.frequencia == 1) {
            atividades.find(e => e.idAtividade == contratoAtividade.idAtividade && e.idIndiceAtividade == contratoAtividade.idIndiceAtividade).valorCNPJ = {
              valorAnterior: atividade.valor,
              valorAtual: atividade.valorAprovacao,
              valorDiferenca: this.calculateDifference(
                atividade.valor,
                atividade.valorAprovacao
              ),
            }
          } else {
            atividades.find(e => e.idAtividade == contratoAtividade.idAtividade && e.idIndiceAtividade == contratoAtividade.idIndiceAtividade).valorOutroCNPJ = {
              valorAnterior: atividade.valor,
              valorAtual: atividade.valorAprovacao,
              valorDiferenca: this.calculateDifference(
                atividade.valor,
                atividade.valorAprovacao
              ),
            }

            atividades.find(e => e.idAtividade == contratoAtividade.idAtividade && e.idIndiceAtividade == contratoAtividade.idIndiceAtividade).frequencia = atividade.frequencia != 1
          }
        } else {
          if (atividade.frequencia == 1) {
            atividadeObj.valorCNPJ = {
              valorAnterior: atividade.valor,
              valorAtual: atividade.valorAprovacao,
              valorDiferenca: this.calculateDifference(
                atividade.valor,
                atividade.valorAprovacao
              ),
            }
          } else {
            atividadeObj.valorOutroCNPJ = {
              valorAnterior: atividade.valor,
              valorAtual: atividade.valorAprovacao,
              valorDiferenca: this.calculateDifference(
                atividade.valor,
                atividade.valorAprovacao
              ),
            }
          }

          atividades.push({
            ...atividadeObj,
            isOutroCNPJ: atividade.frequencia != 1,
            data: informe.dtInforme,
            nomeAtividade: contratoAtividade?.desAtividade,
            idAtividade: contratoAtividade?.idAtividade,
            idIndiceAtividade: contratoAtividade?.idIndiceAtividade,
          });
        }
      }

      this.Atividades = atividades;
    } catch (error) {
      this.globalService.presentToast(error.erro ? error.erro : 'Não foi possível carregar o informe.', ToastColors.danger);
      this.dismiss();
    }
    finally {
      loading.dismiss();
    }
  }

  justificativaReprovacao: string = '';
  isModalReprovacao: boolean = false;

  setOpenModalReprovacao(open: boolean) {
    this.isModalReprovacao = open;
  }

  async onReplyInforme(response: 'aprovar' | 'reprovar' | 'reprovarMsg') {
    let loading = await this.loadingController.create({
      message: 'Aguarde...',
    });

    loading.present();

    if (response == 'reprovarMsg') {
      // TODO Modal motivo da reprovação.

      loading.dismiss();

      this.setOpenModalReprovacao(true);
      return;
    } else if (response == 'reprovar') {
      this.setOpenModalReprovacao(false);
    }

    this.tarefasProvider.responderTarefa(
      response == 'aprovar',
      {
        operacao: 'responderInforme',
        idAtividadeBPM: this.idAtividade,
        idInstanciaBPM: this.id,
        atividades: this.Atividades.length ? JSON.stringify(this.Atividades) : null,
        ...(this.justificativaReprovacao && {comentario: this.justificativaReprovacao})
      }
    ).then((res) => {
      if (res.erro) {
        this.globalService.presentToast(res.erro, ToastColors.danger);
      } else {
        this.globalService.presentToast(
          `Informe ${
            response === 'aprovar' ? 'aprovado' : 'reprovado'
          } com sucesso!`,
          ToastColors.success
        );
        this.events.publish('communication.getTarefas', {});
        this.modalCtrl.dismiss();
      }
    }).catch((err) => {
      if (err.erro) {
        this.globalService.presentToast(err.erro, ToastColors.danger);
      } else {
        this.globalService.presentToast(
          'Não foi possível responder o comunicado.',
          ToastColors.danger
        );
      }

      this.globalService.devlog(err);
    }).finally(() => {
      loading.dismiss();
    });
  }

  async previewFile(fileId: string) {
    const loading = await this.loadingController.create({
      message: 'Carregando...',
    });

    loading.present();

    this.comunicacaoProvider
      .getFilesByIds([fileId])
      .then((res) => {
        if (Array.isArray(res.rows) && res.rows.length > 0) {
          const file = res.rows[0];

          if (this.isMobile) {
            const url = file.urlDownload;
            const link = document.createElement('a');
            link.setAttribute('href', url);
            link.setAttribute('download', file.nome);
            document.body.appendChild(link);
            link.click();
            link.remove();
          } else {
            const url = file.urlVisualizacao;
            window.open(url, '_blank');
          }
        } else {
          this.globalService.devconsole('Arquivo não encontrado', res);

          this.globalService.presentToast(
            'Arquivo não encontrado para visualização',
            ToastColors.tertiary
          );
        }
      })
      .finally(() => {
        loading.dismiss();
      });
  }

  dismiss() {
    this.modalCtrl.dismiss();
  }

  print() {
    window.print();
  }
}
